<template>
  <button
    type="button"
    class="sx-switch"
    :class="{ on: modelValue }"
    role="switch"
    :aria-checked="modelValue ? 'true' : 'false'"
    :aria-label="label || undefined"
    :disabled="disabled"
    @click="$emit('update:modelValue', !modelValue)"
  >
    <span class="sx-switch-knob"></span>
  </button>
</template>

<script setup>
defineProps({
  modelValue: { type: Boolean, default: false },
  label: { type: String, default: '' },
  disabled: { type: Boolean, default: false }
})
defineEmits(['update:modelValue'])
</script>

<style scoped>
.sx-switch {
  position: relative; flex-shrink: 0; width: 44px; height: 24px; padding: 0;
  border: none; border-radius: 999px; background: #d1d5db; cursor: pointer;
  transition: background-color .2s cubic-bezier(.16, 1, .3, 1);
}
.sx-switch-knob {
  position: absolute; top: 3px; left: 3px; width: 18px; height: 18px; border-radius: 50%;
  background: #fff; box-shadow: 0 1px 2px rgba(0, 0, 0, .25);
  transition: transform .2s cubic-bezier(.16, 1, .3, 1);
}
.sx-switch.on { background: var(--brand-primary, #4f46e5); }
.sx-switch.on .sx-switch-knob { transform: translateX(20px); }
.sx-switch:focus-visible { outline: 2px solid var(--brand-primary, #4f46e5); outline-offset: 2px; }
.sx-switch:disabled { opacity: .5; cursor: not-allowed; }
@media (prefers-reduced-motion: reduce) {
  .sx-switch, .sx-switch-knob { transition: none; }
}
</style>
